import { els } from "./elements";
import { fmtG, climate } from "../lib/format";
import { fmtWeight, fmtWeightHint, fmtTempSys, ingredientKey, type UnitSystem } from "../lib/units";
import { loadHistory, snapName, snapMeta } from "../history/history";
import type { Style, DoughResult } from "../types";
import type { Ferment } from "./controls";

export function render(
  s: Style, count: number, unit: number, totalDough: number,
  result: DoughResult, warning: string, ferment: Ferment, sys: UnitSystem,
): void {
  els.slipStyle.textContent = s.name;
  const unitWord = s.geometry === "ball" ? (count === 1 ? "ball" : "balls")
                                         : (count === 1 ? "unit" : "units");
  els.slipMeta.textContent = `${count} ${unitWord} · ${unit} g each`;

  const when = ferment.extended ? `~${ferment.expH}h` : `${ferment.hours}h`;
  els.slipProof.textContent = `Proof ${when} at ${fmtTempSys(ferment.temp, sys)} · ${climate(ferment.temp)}`;
  els.slipProof.classList.toggle("extended", ferment.extended);

  els.ingredients.innerHTML = "";
  result.rows.filter(Boolean).forEach((r) => {
    const row = r!;
    const li = document.createElement("li");
    if (row.accent) li.className = "accent";
    const left = document.createElement("div");
    const name = document.createElement("div");
    name.className = "ing-name"; name.textContent = row.name;
    left.appendChild(name);
    if (row.pct != null) {
      const pct = document.createElement("div");
      pct.className = "ing-pct"; pct.textContent = row.pct + "%";
      left.appendChild(pct);
    }
    const wt = document.createElement("span");
    wt.className = "ing-wt"; wt.textContent = fmtWeight(row.weight, ingredientKey(row.name), sys);
    li.appendChild(left); li.appendChild(wt);
    els.ingredients.appendChild(li);
  });

  els.totalOut.textContent = sys === "us" ? fmtWeightHint(totalDough) : fmtG(totalDough);
  els.warn.hidden = !warning;
  els.warn.textContent = warning;

  els.methodSteps.innerHTML = "";
  (s.method || []).forEach((step) => {
    const li = document.createElement("li");
    li.textContent = step;
    els.methodSteps.appendChild(li);
  });
}

export function renderHistory(): void {
  const list = loadHistory();
  els.saved.hidden = list.length === 0;
  els.historyList.innerHTML = "";
  list.forEach((s) => {
    const li = document.createElement("li");
    li.className = "hist-item";
    const load = document.createElement("button");
    load.type = "button"; load.className = "hist-load"; load.dataset.id = s.id!;
    const name = document.createElement("div");
    name.className = "hist-name"; name.textContent = snapName(s);
    const meta = document.createElement("div");
    meta.className = "hist-meta"; meta.textContent = snapMeta(s);
    load.appendChild(name); load.appendChild(meta);
    const del = document.createElement("button");
    del.type = "button"; del.className = "hist-del"; del.dataset.del = s.id!;
    del.setAttribute("aria-label", `Delete ${snapName(s)}`);
    del.textContent = "×";
    li.appendChild(load); li.appendChild(del);
    els.historyList.appendChild(li);
  });
}
